module.exports = {
  en: {
    'HRES6OEC1': {
      '10': 'Latitude',
      '20': 'Longtitude',
      '30': 'LAST CHECK IN OUT TIME',
      '40': 'Nearby Company'
    },
    'HRES6OEC2': {
      '10': 'Others',
      '20': 'Reason',
      '30': 'Description',
      '40': 'New Customer Name',
      '50': 'Contact Name',
      '60': 'Phone',
      '70': 'Company have not location',
      '80': 'Capture Check In',
      '90': 'Capture Check Out'
    },
    'HRES6OEC3': {
      '10': 'Unspecified Customer Location',
      '20': 'Customer Code',
      '30': 'Customer Name',
      '40': 'Address'
    },
    'HRES6OEC4': {
      '10': 'Others',
      '20': 'Reason',
      '30': 'Description',
      '40': 'New Customer Name',
      '50': 'Contact Name',
      '60': 'Phone',
      '70': 'Company have not location',
      '80': 'Capture Check In',
      '90': 'Capture Check Out'
    }
  },
  th: {
    'HRES6OEC1': {
      '10': 'ละติจูด',
      '20': 'ลองติจูด',
      '30': 'เวลา Check Out ล่าสุด',
      '40': 'Nearby Company'
    },
    'HRES6OEC2': {
      '10': 'อื่นๅ',
      '20': 'เหตุผลการ Check In',
      '30': 'รายละเอียด',
      '40': 'ชื่อบริษัท',
      '50': 'ผู้ติดต่อ',
      '60': 'เบอร์โทรศัพท์',
      '70': 'บริษัทที่ยังไม่กำหนด Location',
      '80': 'ถ่ายรูป Check In',
      '90': 'ถ่ายรูป Check Out'
    },
    'HRES6OEC3': {
      '10': 'รายชื่อบริษัทที่ยังไม่กำหนด Location',
      '20': 'รหัสบริษัท',
      '30': 'ชื่อบริษัท',
      '40': 'ที่อยู่'
    },
    'HRES6OEC4': {
      '10': 'อื่นๅ',
      '20': 'เหตุผลการ Check In',
      '30': 'รายละเอียด',
      '40': 'ชื่อบริษัท',
      '50': 'ผู้ติดต่อ',
      '60': 'เบอร์โทรศัพท์',
      '70': 'บริษัทที่ยังไม่กำหนด Location',
      '80': 'รูปถ่ายตอน Check In',
      '90': 'รูปถ่ายตอน Check Out'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres6oe.js